import { useState, useEffect, useRef } from "react";
import StudentModalSearchFrom from "./StudentModalSearchFrom";
import DataTable from "../../../features/DataTable";
import { getCourseApplicantStudentList } from "../../../../services/apiCourseApplicant";
import styles from "../../../layout/admin/Main.module.scss";
import modalStyles from "../../../layout/admin/Modal.module.scss";

const tableMeata = [
  { key: "login_id", label: "学生番号(8桁)" },
  { key: "name", label: "氏名" },
  { key: "name_kana", label: "フリガナ" },
  { key: "street_name1", label: "町名" },
  { key: "street_name2", label: "丁名" },
  { key: "birthday", label: "生年月日" },
];

const StudentModal = (props) => {
  // 講座ID
  const [courseId, setCourseId] = useState(props.course_id);
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 一覧データ
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const tableResetRef = useRef();
  useEffect(() => {
    if (!props.showFlag) return;
    (async function () {
      const data = await getCourseApplicantStudentList(
        { id: courseId },
        searchCondition,
      );

      if (data == undefined || !data) return;
      setTableData(
        data.map((d) => {
          return {
            key: d.login_id,
            login_id: (
              <a
                href="javascript:void(0);"
                onClick={() =>
                  closeModal(
                    d.user_id,
                    d.login_id,
                    d.is_wheelchair ? `【車いす】${d.name}` : d.name,
                  )
                }
              >
                {d.login_id}
              </a>
            ),
            name: d.is_wheelchair ? `【車いす】${d.name}` : d.name,
            name_kana: d.name_kana,
            street_name1: d.street_name1,
            street_name2: d.street_name2,
            birthday: d.birthday,
          };
        }),
      );
      setTableSortData(
        data.map((d) => {
          return {
            key: d.login_id,
            login_id: d.login_id,
            name: d.name,
            name_kana: d.name_kana,
            street_name1: d.street_name1,
            street_name2: d.street_name2,
            birthday: d.birthday,
          };
        }),
      );
      //ページネーション・ソートをリセット
      tableResetRef.current?.click();
    })();
  }, [searchCondition]);

  const closeModal = (user_id, login_id, name) => {
    // モーダル閉じる
    props.setShowModal(false);
    // 学生情報表示
    props.setStudentDisplay(true);
    // 学生情報セット
    props.setStudentInfo({ user_id: user_id, login_id: login_id, name: name });
  };

  const closeModalNoSet = () => {
    // なにもせずにモーダル閉じる
    props.setShowModal(false);
  };

  return (
    <>
      {props.showFlag ? (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.modalContent}>
            <div className={modalStyles.modalButtonWrap}>
              <button
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModalNoSet()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <div className="sk-main">
              <StudentModalSearchFrom setSearchCondition={setSearchCondition} />
              <DataTable
                tableData={tableData}
                tableMeata={tableMeata}
                tableSortData={tableSortData}
                tableResetRef={tableResetRef}
              />
              <div className={styles.buttonbox}>
                <a onClick={() => closeModalNoSet()}>
                  <span className={styles.decoration}>閉じる</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default StudentModal;
